import AxiosInstance from "../Utils/axios/axiosConfig";

const getJumboReels = async (params) => {
  if (params) {
    const start = (params.page - 1) * params.size;
    const end = start + params.size * 1;
    return AxiosInstance.get(
      `/production/jumbo-reels/?sort_by=${params.sort_by}&sort_type=${params.sort_type}&start=${start}&end=${end}`
    );
  }
  return AxiosInstance.get(`/production/jumbo-reels/`);
};

const getJumboReelDetails = (number) => {
  return AxiosInstance.get(`/production/jumbo-reels/?number=${number}`);
};

const editJumboReel = (body) => {
  return AxiosInstance.put(
    `/production/jumbo-reels/?number=${body.number}`,
    body
  );
};

const addJumboReel = (body) => {
  return AxiosInstance.post(`/production/jumbo-reels/`, body);
};

const deleteJumboReel = (number) => {
  return AxiosInstance.delete(`/production/jumbo-reels/?number=${number}`);
};

const getMappedParentReels = (ids) => {
  return AxiosInstance.post(`/production/parent-reels/?get`, ids);
};

const getParentReelDetails = (id) => {
  return AxiosInstance.get(`/production/parent-reels/?id=${id}`);
};

const getJumboReelDetailsById = async (id) => {
  return await AxiosInstance.get("/production/map-jumbo-reel-details/", {
    params: {
      id: id,
    },
  });
};

const getJumboReelDetailsByIdForMultiStage = async (id, type) => {
  return await AxiosInstance.get("/production/map-jumbo-reel-details/", {
    params: {
      id: id,
      type: type
    },
  });
};

const getParentReelDetailsById = async (id) => {
  return await AxiosInstance.get("/production/parent-reels/", {
    params: {
      id: id,
    },
  });
};

const getCuttingParentReelDetailsById = async (id) => {
  return await AxiosInstance.get(`production/cutting-patterns/?id=${id}`);
};

const cancelProduction = async (body) => {
  return await AxiosInstance.put("/production/cancel/", body);
};

const cancelMultiStageProduction = async (body) => {
  return await AxiosInstance.put("production/multistage/cancel/", body);
};

const cancelParentReelProduction = async (body) => {
  return await AxiosInstance.put("/production/parent-reels/cancel/", body);
};

const cancelMultiStageParentSet = async (body) => {
  return await AxiosInstance.put("/production/multistage/parent-reels/cancel/", body);
};

const cancelCuttingMultiStageParentSet = async (body) => {
  return await AxiosInstance.put("/production/cutting-patterns/cancel/", body);
};

const getProductionDetails = async (params, source = undefined) => {
  if (params.page && params.size) {
    const start = (params.page - 1) * params.size;
    const end = start + params.size * 1;
    return AxiosInstance.get(
      `/production/details/?start=${start}&end=${end}&status=${params.status}&sort_by=${params.sort_by}&sort_type=${params.sort_type}`
    );
  } else {
    if(source){
      return AxiosInstance.get(`/production/details/?status=${params.status}`,{cancelToken: source?.token});
    }else{
      return AxiosInstance.get(`/production/details/?status=${params.status}`);
    }
  }
};

const getMultistageProductionDetails = async (filter, params, status, source = undefined) => {
  if (params.page && params.size && filter) {
    const start = (params.page - 1) * params.size;
    const end = start + params.size * 1;
    if(source){
      return AxiosInstance.post(
        `/production/details/filter/reel-sheet/?start=${start}&end=${end}&sort_by=${params.sort_by}&sort_type=${params.sort_type}&status=produced&status=rejected`,
        filter,
        { cancelToken: source?.token }
      );
    } else{
      return AxiosInstance.post(
        `/production/details/filter/reel-sheet/?start=${start}&end=${end}&sort_by=${params.sort_by}&sort_type=${params.sort_type}&status=produced&status=rejected`,
        filter
      );
    }
  } else{
    if(source){
      return AxiosInstance.post(`/production/details/filter/reel-sheet/`, filter ,{cancelToken: source?.token});
    } else{
      return AxiosInstance.post(`/production/details/filter/reel-sheet/`,filter);
    }
  }
};

const getMultistageAllProductionDetails = async (params, status, source = undefined) => {
  if (params.page && params.size) {
    const start = (params.page - 1) * params.size;
    const end = start + params.size * 1;
    if(source){
      return AxiosInstance.get(
        `/production/details/reel-sheet/?start=${start}&end=${end}&sort_by=${params.sort_by}&sort_type=${params.sort_type}&status=produced&status=rejected`,
        { cancelToken: source?.token }
      );
    } else{
      return AxiosInstance.get(
        `/production/details/reel-sheet/?start=${start}&end=${end}&sort_by=${params.sort_by}&sort_type=${params.sort_type}&status=produced&status=rejected`);
    }
  } else{
    if(source){
      return AxiosInstance.get(`/production/details/reel-sheet/`,{cancelToken: source?.token});
    } else{
      return AxiosInstance.get(`/production/details/reel-sheet/`);
    }
  }
};

const searchProductionDetails = async (pattern, params, source = undefined) => {
  const start = (params.page - 1) * params.size;
  const end = start + params.size * 1;
  if(!params.size && !params.page){
    if(source){
    return AxiosInstance.get(`/production/details/?search`, {
      params: {
        type: "contains",
        pattern: pattern,
        sort_by: params.sort_by,
        sort_type: params.sort_type,
        status: params.status,
      },
      cancelToken: source?.token
    });
  } else{ 
    return AxiosInstance.get(`/production/details/?search`, {
      params: {
        type: "contains",
        pattern: pattern,
        sort_by: params.sort_by,
        sort_type: params.sort_type,
        status: params.status,
      },
    });
  }
  } else {
    return AxiosInstance.get(`/production/details/?search`, {
      params: {
        type: "contains",
        pattern: pattern,
        sort_by: params.sort_by,
        sort_type: params.sort_type,
        start: start,
        end: end,
        status: params.status,
      },
    });
}
};

const getProductionOrderDetails = async (id) => {
  return await AxiosInstance.get("/production/details/", {
    params: { order: id },
  });
};

const getMultistageProdOrderDetails = async (id) => {
  return await AxiosInstance.get(`/production/details/reel-sheet/?order=${id}`);
};

const getMultistageProdStockDetails = async (id) => {
  return await AxiosInstance.get(`/production/details/reel-sheet/?stock=${id}`);
};

const searchMultistageFilteredProductionDetails = async (filter, params, pattern, source = undefined) => {
  if (params.page && params.size && filter) {
    const start = (params.page - 1) * params.size;
    const end = start + params.size * 1;
    if(source){
      return AxiosInstance.post(
        `/production/details/filter/reel-sheet/?search&start=${start}&end=${end}&sort_by=${params.sort_by}&sort_type=${params.sort_type}&status=produced&status=rejected&type=contains&pattern=${pattern}`,
        filter,
        { cancelToken: source?.token }
      );
    } else{
      return AxiosInstance.post(
        `/production/details/filter/reel-sheet/?search&start=${start}&end=${end}&sort_by=${params.sort_by}&sort_type=${params.sort_type}&status=produced&status=rejected&type=contains&pattern=${pattern}`,
        filter
      );
    }
  } else{
    if(source){
      return AxiosInstance.post(`/production/details/filter/reel-sheet/`, filter ,{cancelToken: source?.token});
    } else{
      return AxiosInstance.post(`/production/details/filter/reel-sheet/`,filter);
    }
  }
};

const exportMultistageDetails = async (body, startEndParams, params, source = undefined) => {
  if(source){
    return AxiosInstance.post(`/production/details/filter/reel-sheet/?start=${startEndParams.start}&end=${startEndParams.end}&sort_by=${params.sort_by}&sort_type=${params.sort_type}&status=produced&status=rejected`,
    body, { cancelToken: source?.token });
  } else{
    return AxiosInstance.post(`/production/details/filter/reel-sheet/?start=${startEndParams.start}&end=${startEndParams.end}&sort_by=${params.sort_by}&sort_type=${params.sort_type}&status=produced&status=rejected`, body);
  }
};

const exportSearchProdMultistageDetails = async (body, startEndParams, params, pattern, source = undefined) => {
  if(source){
    return AxiosInstance.post(`/production/details/filter/reel-sheet/?search&start=${startEndParams.start}&end=${startEndParams.end}&sort_by=${params.sort_by}&sort_type=${params.sort_type}&status=produced&status=rejected&type=contains&pattern=${pattern}`,
    body,
    { cancelToken: source?.token })
  } else{
    return AxiosInstance.post(`/production/details/filter/reel-sheet/?search&start=${startEndParams.start}&end=${startEndParams.end}&sort_by=${params.sort_by}&sort_type=${params.sort_type}&status=produced&status=rejected&type=contains&pattern=${pattern}`, body);
  }
}

const markParentReelsStatus = async (body) => {
  return await AxiosInstance.put("/production/mark-reels/", body);
};

const markParentReelsRewindingStatus = async (body) => {
  return await AxiosInstance.put("production/mark-rewinding-reels/", body);
};

const markParentSheetStatus = async (body) => {
  return await AxiosInstance.put("/production/mark-sheets/", body);
};

const markParentSheetCuttingStatus = async (body) => {
  return await AxiosInstance.put("/production/mark-cutting-sheets/", body);
};

const mapJumboReel = async (body, type) => {
  if(type == "edit"){
    return await AxiosInstance.put("/production/jumbo-reels/map/?edit", body);
  } else{
    return await AxiosInstance.put("/production/jumbo-reels/map/", body);
  }
};

const mapJumboReelForCutter = async (body, type) => {
  if(type == "edit"){
    return await AxiosInstance.put("production/jumbo-reels/map-sheets/?edit", body);
  } else{
    return await AxiosInstance.put("production/jumbo-reels/map-sheets/", body);
  }
};

const removeJumboReelMapping = async (body) => {
  return await AxiosInstance.put("/production/jumbo-reels/map/?remove", body);
};

const getExportParentReelDetails = (body) => {
  return AxiosInstance.post(`/production/parent-reels/export/`, body);
};

const exportAllParentReelDetails = (body) => {
  return AxiosInstance.post(`/production/parent-reels/export/?bulk`, body);
};

const searchJumboReels = async (pattern = "", params = {}) => {
  const start = (params.page - 1) * params.size;
  const end = start + params.size * 1;
  let response;
  if(!params.size && !params.page){ 
      response = await AxiosInstance.get("production/jumbo-reels/?search", {
      params: {
        type: "contains",
        pattern: pattern,
        sort_by: params.sort_by,
        sort_type: params.sort_type,
      },
    });
  } else{
    response = await AxiosInstance.get("production/jumbo-reels/?search", {
      params: {
        type: "contains",
        pattern: pattern,
        sort_by: params.sort_by,
        sort_type: params.sort_type,
        start: start,
        end: end,
      },
    });
}
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

const getFilteredJumboReels = async (sort, filter) => {
  if (sort) {
    const start = (sort.page - 1) * sort.size;
    const end = start + sort.size * 1;
    const response = await AxiosInstance.post(
      `/production/jumbo-reels/filter/?sort_by=${sort.sort_by}&sort_type=${sort.sort_type}&start=${start}&end=${end}`,
      filter
    );
    if (!response.data.error) {
      return response.data;
    } else {
      return Promise.reject(response);
    }
  } else {
    const response = await AxiosInstance.post(
      `/production/jumbo-reels/filter/`,
      filter
    );
    if (!response.data.error) {
      return response.data;
    } else {
      return Promise.reject(response);
    }
  }
};

const getFilteredProductionDetails = async (params, filter, source = undefined) => {
  if (params.page && params.size) {
    const start = (params.page - 1) * params.size;
    const end = start + params.size * 1;
    return AxiosInstance.post(
      `/production/details/filter/?start=${start}&end=${end}&status=${params.status}&sort_by=${params.sort_by}&sort_type=${params.sort_type}`,
      filter
    );
  } else{
    if(source){
      return AxiosInstance.post(
        `/production/details/filter/?status=${params.status}`,
        filter,
        {cancelToken: source?.token}
      );
    } else{
      return AxiosInstance.post(
        `/production/details/filter/?status=${params.status}`,
        filter
      );
    }
  }    
};

const getJumboReelsForMapping = (jobcard, jobcardType) => {
  // return AxiosInstance.get(
  //   `/production/jumbo-reels/?mapping&jobcard=${jobcard}&type=${jobcardType}`
  // );
  return AxiosInstance.get(
    `/production/jumbo-reels/?mapping&jobcard=${jobcard}`
  );
};

const closeJumboReel = (number, body) => {
  return AxiosInstance.put(`/production/jumbo-reels/?number=${number}`, body);
};

const changeJumboReelStatus = async (body = {}) => {
  const response = await AxiosInstance.put("/production/jumbo-reels/status/", body);
  return response.data;
};

const changeProductionJobCardState = async (body = {}) => {
  const response = await AxiosInstance.put("/production/jobcards/state/", body);
  return response.data;
};

const changeMultiStageProductionJobCardState = async (body = {}) => {
  const response = await AxiosInstance.put("production/jobcards/multistage/state/", body);
  return response.data;
};

const markCompleteRewinding = async (body = {}) => {
  const response = await AxiosInstance.put("/production/complete-rewinding-reels/", body);
  return response.data;
};

const markCompleteCutting = async (body = {}) => {
  const response = await AxiosInstance.put("/production/complete-cutting-sheets/", body);
  return response.data;
};

const getProductionJobCardsInfo = async (params, state) => {
  let response;
  if (!params) {
    response = await AxiosInstance.get("/production/jobcards-info/");
    return response.data.data;
  }
  const start = (params.page - 1) * params.size;
  const end = start + params.size * 1;
  if (state) {
    response = await AxiosInstance.get(
      `/production/jobcards-info/?state=${state}&start=${start}&end=${end}`
    );
  } else {
    response = await AxiosInstance.get(
      `/production/jobcards-info/?start=${start}&end=${end}`
    );
  }
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

const getFilteredJobcards = async (params, filter, state) => {
  const start = (params.page - 1) * params.size;
  const end = start + params.size * 1;
  const response = state
    ? await AxiosInstance.post(
        `/jobcards/filter/?state=${state}&start=${start}&end=${end}`,
        filter
      )
    : await AxiosInstance.post(
        `/jobcards/filter/?start=${start}&end=${end}`,
        filter
      );
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

const getProductionJobCardsById = async (id = "") => {
  const response = await AxiosInstance.get("/production/jobcards/", {
    params: {
      id,
    },
  });
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

export const getProductionJobCardsByIdMultistage = async (id = "") => {
  const response = await AxiosInstance.get("/jobcards/multistage/", {
    params: {
      id,
    },
  });
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

const getExportDataForJumboReel = async (body = {}) => {
  const response = await AxiosInstance.get("/production/jumbo-reels/export/", body);
  return response.data;
}

const getExportDataForFilteredJumboReel = async (body) => {
  const response = await AxiosInstance.post("/production/jumbo-reels/export/", body);
  return response.data;
}

const searchJumboReelsMappingDetails = async (id, value) => {
  const response = await AxiosInstance.get(
    `/production/jumbo-reels/mapping/search/?number=${id}&pattern=${value}&start=0&end=20&sort_by=created_at&sort_type=ascending`
    );
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
}

const searchJobCardForProdPlanning = async (id) => {
  const response = await AxiosInstance.get(`/production/jobcards-info/?search&pattern=${id}`);
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
}

export const cancelSets = async (body) => {
  const response = await AxiosInstance.put('/production/parent-reels/cancel/bulk/', body);
  return response.data;
}
export const cancelSetsMultistage = async (body) => {
  const response = await AxiosInstance.put('/production/multistage/parent-reels/cancel/bulk/', body);
  return response.data;
}
export const cylinderReorder = async (body) => {
  const response = await AxiosInstance.put('/short-jobcard-cylinders/?parent_set', body);
  return response.data;
}
export const cylinderReorderMultistage = async (body) => {
  const response = await AxiosInstance.put('/short-jobcard-cylinders/multistage/?parent_set', body);
  return response.data;
}
export const cancelSheetWeight = async (body) => {
  const response = await AxiosInstance.put("/production/cutting-patterns/cancel/partial/", body);
  return response.data;
}
export const rearrangeCuttingPatterns = async (body) => {
  const response = await AxiosInstance.put("/jobcards/cutting-pattern/", body);
  return response.data;
}

export const replanJobcard = async (body,type) => {
  let response
  if(type==='simplex'){
    response= await AxiosInstance.post("jobcards/new-solution-2d/?algorithm_data", body);
  }
  else if(type==='duplex'){
    response= await AxiosInstance.post("/jobcards/new-solution-2d/duplex/?algorithm_data", body);
  }
  else if(type==='multistage'){
    response= await AxiosInstance.post("/jobcards/new-solution/multistage/?algorithm_data", body);
  }
  else{
 response = await AxiosInstance.post("/jobcards/new-solution/?algorithm_data", body);
  }
  // return response.data;
   if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
}
export {
  getJumboReels,
  getJumboReelDetails,
  editJumboReel,
  addJumboReel,
  deleteJumboReel,
  getMappedParentReels,
  getParentReelDetails,
  searchProductionDetails,
  getJumboReelDetailsById,
  getParentReelDetailsById,
  cancelProduction,
  cancelParentReelProduction,
  getProductionDetails,
  getProductionOrderDetails,
  mapJumboReel,
  markParentReelsStatus,
  removeJumboReelMapping,
  getExportParentReelDetails,
  exportAllParentReelDetails,
  searchJumboReels,
  getFilteredJumboReels,
  getFilteredProductionDetails,
  getJumboReelsForMapping,
  closeJumboReel,
  changeProductionJobCardState,
  getProductionJobCardsInfo,
  getFilteredJobcards,
  getProductionJobCardsById,
  changeJumboReelStatus,
  getExportDataForJumboReel,
  getExportDataForFilteredJumboReel,
  searchJumboReelsMappingDetails,
  searchJobCardForProdPlanning,
  mapJumboReelForCutter,
  markParentSheetStatus,
  getJumboReelDetailsByIdForMultiStage,
  getCuttingParentReelDetailsById,
  markParentReelsRewindingStatus,
  markParentSheetCuttingStatus,
  cancelMultiStageParentSet,
  cancelCuttingMultiStageParentSet,
  changeMultiStageProductionJobCardState,
  cancelMultiStageProduction,
  markCompleteRewinding,
  markCompleteCutting,
  getMultistageProductionDetails,
  getMultistageAllProductionDetails,
  getMultistageProdOrderDetails,
  getMultistageProdStockDetails,
  searchMultistageFilteredProductionDetails,
  exportMultistageDetails,
  exportSearchProdMultistageDetails
};
